module.exports = __webpack_public_path__ + "static/band-animation-d0455d24f791c5aa04197e117aa470e5.gif";